<template>
  <app-content>
    <versions-view />
  </app-content>
</template>

<script>
import VersionsView from '@/domain/components/generalPanel/versions/VersionsView';

export default {
  components: {
    VersionsView,
  },
};
</script>
